'use strict';

import { eventConfig } from "../project-info/eventConfig";

// base option
export const DISTANCE_OPTIONS = {
  '25-miles': {
    display: '25 Miles',
    slug: 25
  },
  '50-miles': {
    display: '50 Miles',
    slug: 50
  },
  '100-miles': {
    display: '100 Miles',
    slug: 100
  },
  '250-miles': {
    display: '250 Miles',
    slug: 250
  }
};

// base option
export const DATE_OPTIONS = {
  'today': {
    display: 'Today',
    slug: 'today'
  },
  'all': {
    display: 'All Upcoming',
    slug: 'all'
  },
  'next-7': {
    display: 'Next 7 Days',
    slug: 'next-7'
  },
  'next-30': {
    display: 'Next 30 days',
    slug: 'next-30'
  },
  'past-90': {
    display: 'Past 90 days',
    slug: 'past-90'
  }
};

// TODO: Determine local group options, configable?
export const GROUP_OPTIONS = eventConfig.LOCAL_GROUP_OPTIONS;

// TODO: Determine virtual group options, configable?
export const VIRTUAL_GROUP_OPTIONS = eventConfig.VIRTUAL_GROUP_OPTIONS;

export const VIRTUAL_TIME_OPTIONS = eventConfig.VIRTUAL_TIME_OPTIONS;

export const WORKSPACE_ONLY_OPTIONS = eventConfig.WORKSPACE_ONLY_OPTIONS;

// do we want distance? All variants but DBA would have events that could have varying distances. Should only apply to local events
export const SORT_OPTIONS = {
  // 'distance': {
  //   display: 'Distance',
  //   slug: 'distance'
  // },
  'date': {
    display: 'Date',
    slug: 'date'
  },
  'attendees': {
    display: 'Attendees',
    slug: 'attendees'
  }
};


// GROUP_EVENT_OPTIONS and VIRTUAL_EVENT_SUBTYPES are now specified in the projectConfig, and also exported here
// so we don't have to redo a bunch of lines and so it is also consistent with both the other option lists
// and the projectConfig namespacing
export const GROUP_EVENT_OPTIONS = eventConfig.group_event_options;

export const VIRTUAL_EVENT_SUBTYPES = eventConfig.virtual_event_subtypes;

export const GROUP_EVENT_OPTIONS_SORTED = Object.fromEntries(
  Object.entries(GROUP_EVENT_OPTIONS).sort((a, b) => a[0].localeCompare(b[0]))
);

export const FEATURED_LOZENGE_COUNT = eventConfig.featured_lozenge_count;
